import { Injectable } from '@angular/core';
import * as jsts from 'jsts';
import {
  LineString,
  LinearRing,
  MultiLineString,
  MultiPoint,
  MultiPolygon,
  Point,
  Polygon,
  Geometry,
} from 'ol/geom';

@Injectable({
  providedIn: 'root',
})
export class JstsHelperService {
  private parser = new jsts.io.OL3Parser();

  constructor() {
    // @ts-ignore: ts doesn't have an up-to-date type for parser instance
    this.parser.inject(
      Point,
      LineString,
      LinearRing,
      Polygon,
      MultiPoint,
      MultiLineString,
      MultiPolygon,
    );
  }

  safeIntersectsByParsing(geometry1: Geometry, geometry2: Geometry): boolean {
    const geom1 = this.parser.read(geometry1);
    const geom2 = this.parser.read(geometry2);
    return this.safeIntersects(geom1, geom2);
  }

  safeIntersects(geom1: jsts.geom.Geometry, geom2: jsts.geom.Geometry): boolean {
    if (!this.areGeometriesValid(geom1, geom2)) {
      return false;
    }
    return geom1.intersects(geom2);
  }

  areGeometriesValid(...geometries: jsts.geom.Geometry[]): boolean {
    let areValid = true;
    geometries.forEach((geometry) => {
      if (!geometry.isValid()) {
        return false;
      }
      geometry.getCoordinates().forEach((coordinates) => {
        if (!((coordinates.x || coordinates.x === 0) && (coordinates.y || coordinates.y === 0))) {
          areValid = false;
        }
      });
    });
    return areValid;
  }
}
